import './InitiativesChampionsPage.scss'
import Heading from '../Heading/Heading'
import BackToTop from '../BackToTop/BackToTop'
import LinkWithArrow from '../LinkWithArrow/LinkWithArrow'
import Text from '../Text/Text'

const InitiativesChampionsPage = (data) => {
  let championCards = data.championCards
  return (
    <div className="p-champions-and-initiatives">
      <aside className="m-sticky-nav">
        <nav className="m-sticky-nav__nav">
          <ul className="m-sticky__nav-items">
            {championCards &&
              championCards.map((champions, index) => (
                <li className="m-sticky__nav-item" key={index}>
                  <a
                    href={`#champions-${index}`}
                    className="m-sticky__nav-link">
                    {champions.title}
                  </a>
                </li>
              ))}
          </ul>
        </nav>
      </aside>
      <div className="champions-container">
        {championCards &&
          championCards.map((champions, index) => (
            <div
              className="champions-card"
              id={`champions-${index}`}
              key={index}>
              <Heading headingSize="h3" className="champions-card-title">
                {champions.title}
              </Heading>
              <Heading
                type="h3"
                headingSize="h4"
                className={
                  champions.why ? 'champions-card-subtitle' : 'hidden'
                }>
                Why?
              </Heading>
              <Text>{champions.why}</Text>
              <Heading
                type="h3"
                headingSize="h4"
                className={
                  champions.how ? 'champions-card-subtitle' : 'hidden'
                }>
                How?
              </Heading>

              <Text>{champions.how}</Text>
              <Heading
                type="h3"
                headingSize="h4"
                className={
                  champions.who ? 'champions-card-subtitle' : 'hidden'
                }>
                Who?
              </Heading>
              <div className="who-container">
                {champions.who.map((who, index) => (
                  <div className="who" key={index}>
                    <Text
                      fontSize="large"
                      fontWeight="bold"
                      className="champions-name">
                      {who.fields.name}
                    </Text>
                    <Text className="champions-role">{`${who.fields.squad} | ${who.fields.role}`}</Text>
                  </div>
                ))}
              </div>

              <LinkWithArrow
                to={champions.link}
                external={true}
                className={champions.link ? 'champions-link' : 'hidden'}>
                More Information
                <span className="u-visually-hidden">{champions.title}</span>
              </LinkWithArrow>
            </div>
          ))}

        <BackToTop />
      </div>
    </div>
  )
}

export default InitiativesChampionsPage
